import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/Footer";
import ErrorBoundary from "../api/ErrorBoundary";
import SeoLoader from "../components/seo/SeoLoader";
import AccountNavbar from "../components/navbar/AccountNavbar";
import SomeThingWentWrong from "../components/somethingwentwrong/SomeThingWentWrong";
import { Suspense } from "react";
import { useSelector } from "react-redux";

const AccountSectionLayout = () => {
  const globalerror = useSelector(
    (state: { ID: { globalError: boolean } }) => state.ID.globalError
  );

  if (globalerror) return <SomeThingWentWrong />;

  return (
    <ErrorBoundary>
      <SeoLoader />
      <Suspense>
        <Navbar />
        <div className="container py-0 py-md-5">
          <div className="row">
            <AccountNavbar />
            <div className="col main-content-account ms-md-3  m-0">
              <Outlet />
            </div>
          </div>
        </div>
        <Footer />
      </Suspense>
    </ErrorBoundary>
  );
};

export default AccountSectionLayout;
